/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './strongRef.defs.js'
export * as $defs from './strongRef.defs.js'
